import { render } from "./conferenceMainPage.vue?vue&type=template&id=3cbd32d4&scoped=true"
import script from "./conferenceMainPage.vue?vue&type=script&lang=js"
export * from "./conferenceMainPage.vue?vue&type=script&lang=js"

import "./conferenceMainPage.vue?vue&type=style&index=0&id=3cbd32d4&lang=scss&scoped=true"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cbd32d4"]])

export default __exports__